import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export default function Checkbox({
  onClick = () => null,
  label = null,
  checked = false,
  alignSelf = 'flex-start',
  style = {},
}) {
  let circleClass = styles.circle;
  if (checked) {
    circleClass = styles.circleChecked;
  }
  return (
    <div
      style={{ alignSelf, ...style }}
      onClick={() => onClick(!checked)}
      className={classNames(styles.checkbox, {
        [styles.checked]: checked,
      })}
    >
      <div className={circleClass} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
